// extracted by mini-css-extract-plugin
module.exports = {"mobile":"HeroControls_mobile__5CcxZ","desktop":"HeroControls_desktop__XwnSY"};